import { Functions, httpsCallable } from 'firebase/functions';
import { GuestGuideArgs, parseGuestGuideResponse } from '../../models/GuestGuide';
import { endpoint_getGuestGuide } from '../../utils/mrr/cloudEndpointNames';
import { cloud_makeSalesforceRequest } from '../../utils/mrr/cloudFunctions';

export async function guestGuideQuery(args: GuestGuideArgs, functions: Functions) {
  try {
    if (Boolean(args.reservationName) === Boolean(args.listingId)) {
      throw new Error('Provide exactly one reservation or listing for the property guide.');
    }
    const request = httpsCallable(
      functions,
      cloud_makeSalesforceRequest + '?' + endpoint_getGuestGuide
    );
    const response = await request({
      method: 'GET',
      path: '/api/guest/guide/v1',
      params: args.reservationName
        ? { reservation_name: args.reservationName }
        : { listing_id: args.listingId },
      body: '',
    });
    return { data: parseGuestGuideResponse(response.data) };
  } catch (error) {
    return { error };
  }
}
